export default __webpack_public_path__ + "static/media/logo192.edf738a4.png";